module.exports = __webpack_public_path__ + "922338ccb881f7065df2605f07fdd66b.svg";